import React from "react";
import * as PropTypes from "prop-types";

const UISwitchField = ({icon, title, description, bordered, stacked, required, children}) => {
	if( stacked )
	{
		return (
			<div className="switch-field switch-field-stacked">
				{title && <p className="switch-field-title">{required && <span className="switch-field-required">*</span>}{title}</p>}
				{description && <p className="switch-field-description">{description}</p>}
				<div className="switch-field-control">{children}</div>
			</div>
		);
	}

	if( bordered )
	{
		return (
			<div className="switch-field switch-field-bordered">
				{title && <p className="switch-field-title">{required && <span className="switch-field-required">*</span>}{title}</p>}
				<div className="switch-field-control">{children}</div>
				{description && <p className="switch-field-description">{description}</p>}
			</div>
		);
	}

	return (
		<div className="switch-field">
			{icon && <div className="switch-field-icon">{icon}</div>}
			<div className="switch-field-text">
				{title && <p className="switch-field-title">{required && <span className="switch-field-required">*</span>}{title}</p>}
				{description && <p className="switch-field-description">{description}</p>}
			</div>
			<div className="switch-field-control">{children}</div>
		</div>
	);
};

UISwitchField.propTypes = {
	icon       : PropTypes.node,
	title      : PropTypes.string,
	description: PropTypes.string,
	bordered   : PropTypes.bool,
	stacked    : PropTypes.bool,
	required   : PropTypes.bool,
	children   : PropTypes.node,
};

UISwitchField.defaultProps = {
	icon       : null,
	title      : "",
	description: "",
	bordered   : false,
	stacked    : false,
	required   : false,
	children   : null,
};

export default UISwitchField;
